export default "__VITE_ASSET__1aef5b86__"